document.addEventListener('change', function(event) {
  const input = event.target.closest('.featured-collections__filters input[type="radio"]');

  if (!input) return;

  const section = input.closest('.tab-blocks__block');

  if (!section) return;

  const filter = input.value;

  const products = section.querySelectorAll('.featured-collections__slider-product');

  products.forEach((product) => {
    const tags = product.dataset.productTags || '';

    const showProduct =
      filter === 'all' ||
      tags.includes(`,${filter},`);

    product.hidden = !showProduct;
  });

  const heroProducts = section.querySelectorAll('.featured-collections__featured-product--filters .product-card');
  let currentHero = section.querySelector('.featured-collections__featured-product--filters .product-card.active').dataset.productId;
  // console.log("current hero " + currentHero);

  if(heroProducts.length < 1) return;

  heroProducts.forEach(product => {
    product.classList.remove('active');
  });

  // Find the first match and stop
  for (const product of heroProducts) {
    const tags = product.dataset.productTags || '';

    const showProduct =
      filter === 'all' ||
      tags.includes(`,${filter},`);

    if (showProduct) {
      product.classList.add('active');
      currentHero = product.dataset.productId;
      break;
    }
  }

  products.forEach((product) => {
    const productID = product.dataset.productId;

    if(productID == currentHero){
      product.hidden = true;
    }
  });

});

function filterFeaturedCollection(section) {
  
  const selectedFilters = Array.from(section.querySelectorAll('.featured-collections__filters input[type="radio"]:checked')).map(input => input.value);

  // console.log("filter section function is " + selectedFilters);
  const products = section.querySelectorAll('.featured-collections__slider-product');

  products.forEach(product => {
    const tags = product.dataset.productTags || '';

    if (!selectedFilters.length) {
      product.hidden = false;
      return;
    }

    const matches = selectedFilters.every(filter => {
      return tags.includes(`,${filter},`);
    });

    product.hidden = !matches;
  });

  const heroProducts = section.querySelectorAll('.featured-collections__featured-product--filters .product-card');
  let currentHero = "";
  if(heroProducts.length < 1) return;

  // Remove active from all products first
  heroProducts.forEach(product => {
    product.classList.remove('active');
  });

  // Find the first match and stop
  for (const product of heroProducts) {
    const tags = product.dataset.productTags || '';

    // If there are no filters, activate the first product
    if (!selectedFilters.length) {
      product.classList.add('active');
      break;
    }

    const matches = selectedFilters.every(filter => {
      return tags.includes(`,${filter},`);
    });

    if (matches) {
      product.classList.add('active');
      currentHero = product.dataset.productId;
      break;
    }
  }

  products.forEach((product) => {
    const productID = product.dataset.productId;

    if(productID == currentHero){
      product.hidden = true;
    }
  });

}


// RESET FILTERS
document.addEventListener("click", function (event) {
  const resetButton = event.target.closest(".featured-collections__filters .reset-filters");

  if (!resetButton) return;

  const section = resetButton.closest(".tab-blocks__block");

  if (!section) return;

  section
    .querySelectorAll('.featured-collections__filters input[type="radio"]')
    .forEach((input) => {
      input.checked = false;
    });

  section
    .querySelectorAll(".featured-collections__slider-product")
    .forEach((product) => {
      product.hidden = false;
    });

    resetButton.classList.remove('active');
});

// Apply default selected filter on load
document.querySelectorAll('.tab-blocks__block').forEach(block => {
  if (block.querySelector('.featured-collections__filters')) {
    filterFeaturedCollection(block);
  }
});